import { render } from "./TopSellingProducts.vue?vue&type=template&id=1205fa88&scoped=true&ts=true"
import script from "./TopSellingProducts.vue?vue&type=script&lang=ts"
export * from "./TopSellingProducts.vue?vue&type=script&lang=ts"

import "./TopSellingProducts.vue?vue&type=style&index=0&id=1205fa88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1205fa88"]])

export default __exports__